import React, { useContext } from "react";
import CustomToolTipHost from "../../../../components/CustomToolTipHost/CustomToolTipHost";
import studyReportContext from "../../../../context/studyreport/StudyReportContext";
import VapiAssistantIcon from "../../../../components/SVGComponents/VapiAssistantIcon";
import AgenticReportingContext from "../../../../context/agentic-reporting/AgenticReportingContext";
import MobileViewerContext from "../../../../context/studyviewer/MobileViewerContext";
import { isMobile } from "react-device-detect";

const VapiAssistantButton = () => {
  
  const{
    vapiFunctions,
    isTalking,
    isAgenticTab,
    isMicRecording
  } = useContext(AgenticReportingContext);

  const mobileViewerCtx = useContext(MobileViewerContext);
  const setSlideReportOpen = isMobile ? mobileViewerCtx?.setSlideReportOpen : null;

  const handleVapiClick = () => {
    if (!isAgenticTab) return;
    if (isMicRecording) return;

    if (isTalking) {
      vapiFunctions.stopAssistant(true);
      if (setSlideReportOpen) setSlideReportOpen(true);
    } else {
      vapiFunctions.startAssistant();
    }
  };

  let tooltipContent = isTalking ? "Stop Assistant" : "Talk to Assistant";
  if (isMicRecording) {
      tooltipContent = "Turn off mic to use assistant";
  }

  const isDisabled = !isAgenticTab || isMicRecording;

  return (
    <>
      <CustomToolTipHost content={tooltipContent} id="Talk to Assistant">
        <div
          style={{
            cursor: isDisabled ? "not-allowed" : "pointer",
            height: "25.5px",
            width: "30px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "4px",
            boxSizing: "border-box",
            opacity: isMicRecording ? 0.5 : 1
          }}
          onClick={handleVapiClick}
        >
          <VapiAssistantIcon isSpeaking={isAgenticTab && isTalking} />
        </div>
      </CustomToolTipHost>
    </>
  );
};

export default VapiAssistantButton;